
import { assertEquals, assertMultiEquals} from '@/utils/verify-utils'


const getItemById = (list, id) => {
    const index = findById(list, id);
    if(index >= 0) {
        return list[index]
    }
    return {count: -1}
}

const findById = (list, id) => {
    for(let i = 0; i < list.length; i++) {
        if(list[i].id == id) {
            return i;
        }
    }
    return -1;
}

/*
return assertMultiEquals([
    ["", ]
])

*/
const testDB = {}

export default [
    {
        name: "GET /ping should work",
        method: "get",
        url: "/ping",
        handleResponse: (response) => {
            return assertMultiEquals([
                ["Status code", response.status, 200 ],
                ["Response", response.data, "pong" ]
            ])
        },
    },
    {
        name: "POST /clear shall have status 204",
        method: "post",
        url: "/clear",
        handleResponse: (response) => {return assertEquals(response.status, 204)},
    },
    {
        name: "GET /recipes shall be empty after clear",
        method: "get",
        url: "/recipes",
        handleResponse: (response) => {return assertEquals(response.data, [])},
    },
    {
        name: "POST /recipes/create shall accept a new recipe",
        method: "post",
        url: "/recipes/create",
        payload: {name: "MyRecipe", instructions: "Do it", ingredients: [{name: "Sugar", quantity: 1}]},
        handleResponse: (response) => {testDB.firstRecipe = response.data.id; return assertEquals(response.data.name, "MyRecipe")},
    },
    {
        name: "GET /recipes/<id> shall work",
        method: "get",
        url: "/recipes/",
        extendPath: () => testDB.firstRecipe,
        handleResponse: (response) => {return assertEquals(response.data.instructions, "Do it")},
    },
    {
        name: "POST /recipes/create shall accept a (another) new recipe",
        method: "post",
        url: "/recipes/create",
        payload: {name: "SugarCake", instructions: "Mix and bake!", ingredients: [{name: "Sugar", quantity: 2}, {name: "CakeMix", quantity: 1}]},
        handleResponse: (response) => {testDB.secondRecipe = response.data.id; return assertEquals(response.data.name, "SugarCake")},
    },
    {
        name: "GET /recipes/<id> shall work (again)",
        method: "get",
        url: "/recipes/",
        extendPath: () => testDB.secondRecipe,
        handleResponse: (response) => {return assertEquals(response.data.instructions, "Mix and bake!")},
    },
    {
        name: "POST /recipes/create shall reject invalid recipe",
        method: "post",
        url: "/recipes/create",
        payload: {name: "Error1", instructions: "Uh ohh", ingredients: [{name: "too little", quantity: 0}]},
        handleError: (e) => {return assertEquals(e.response.status, 400)}
    },
    {
        // FIXME: Check it is those both recipes
        name: "GET /recipes shall return both recipes",
        method: "get",
        url: "/recipes",
        handleResponse: (response) => {return assertEquals(response.data.length, 2)},
    },
    {
        name: "POST /recipes/<id>/make without enough ingredients shall fail",
        method: "post",
        url: "/recipes/",
        extendPath: () => testDB.secondRecipe + "/make",
        handleError: (e) => {return assertEquals(e.response.status, 400)}
    },
    {
        name: "POST /inventory/fill with enough ingredients for one cake",
        method: "post",
        url: "/inventory/fill",
        payload: [{name: "Sugar", quantity: 3}, {name: "CakeMix", quantity: 1}],
        handleResponse: (response) => {return assertEquals(response.status, 204)},
    },
    {
        name: "POST /inventory/fill with invalid ingredients shall fail",
        method: "post",
        url: "/inventory/fill",
        payload: [{name: "Void", quantity: 0}],
        handleError: (e) => {return assertEquals(e.response.status, 400)}
    },
    {
        name: "GET /inventory have correct quantity",
        method: "get",
        url: "/inventory",
        handleResponse: (response) => {return assertEquals(response.data.length, 2)},
    },
    {
        name: "POST /recipes/<id>/make with enough ingredients)",
        method: "post",
        url: "/recipes/",
        extendPath: () => testDB.secondRecipe + "/make",
        handleResponse: (response) => {return assertEquals(response.data, "Yummy!")},
    },
    {
        name: "GET /inventory have correct reduced quantity",
        method: "get",
        url: "/inventory",
        handleResponse: (response) => {return assertMultiEquals([
            ["Response code", response.status, 200],
            ["Data length", response.data.length, 1],
            ["Name", response.data[0].name, "Sugar"],
            ["Quantity", response.data[0].quantity, 1]
        ])},
    },

    {
        name: "POST /recipes/<id>/make with enough of only some ingredients",
        method: "post",
        url: "/recipes/",
        extendPath: () => testDB.secondRecipe + "/make",
        handleError: (e) => {return assertEquals(e.response.status, 400)}
    },

    {
        name: "GET /inventory has not changed",
        method: "get",
        url: "/inventory",
        handleResponse: (response) => {return assertMultiEquals([
            ["Response code", response.status, 200],
            ["Data length", response.data.length, 1],
            ["Name", response.data[0].name, "Sugar"],
            ["Quantity", response.data[0].quantity, 1]
        ])},
    },


    {
        name: "POST /clear should work on non-empty db",
        method: "post",
        url: "/clear",
        handleResponse: (response) => {return assertEquals(response.status, 204)},
    },
    {
        name: "GET /recipes shall be empty at after clear",
        method: "get",
        url: "/recipes",
        handleResponse: (response) => {return assertEquals(response.data.length, 0)},
    },
    {
        name: "GET /inventory shall be empty at after clear",
        method: "get",
        url: "/inventory",
        handleResponse: (response) => {return assertEquals(response.data.length, 0)},
    },


    {
        name: "Some test ingredients!",
        method: "post",
        url: "/inventory/fill",
        payload: [
            { "name": "Sugar", "quantity": 44 },
            { "name": "Cake mix", "quantity": 11 },
            { "name": "Cinnamon", "quantity": 5 },
            { "name": "Bun", "quantity": 4 },
            { "name": "Pink color", "quantity": 10 }
        ],
        handleResponse: (response) => {return assertEquals(response.status, 204)},
    },


    {
        name: "Create a Sugar Cake recipe",
        method: "post",
        url: "/recipes/create",
        payload: {
            "name": "Sugar Cake",
            "instructions": "Mix, then bake in oven",
            "ingredients": [
                { "name": "Sugar", "quantity": 4 },
                { "name": "Cake mix", "quantity": 1 }
            ]
        },
        handleResponse: (response) => {testDB.sugarCakeId = response.data.id; return assertEquals(response.data.name, "Sugar Cake")},
    },
    {
        name: "Create a Cinnamon Bun recipe",
        method: "post",
        url: "/recipes/create",
        payload: {
            "name": "Cinnamon Bun",
            "instructions": "Put cinnamon on the bun",
            "ingredients": [
                { "name": "Cinnamon", "quantity": 1 },
                { "name": "Bun", "quantity": 1 }
            ]
        },
        handleResponse: (response) => {testDB.cinamonBunId = response.data.id; return assertEquals(response.data.name, "Cinnamon Bun")},
    },
    {
        name: "Create a Cotton Candy recipe",
        method: "post",
        url: "/recipes/create",
        payload:{
            "name": "Cotton Candy",
            "instructions": "Spinn it well!",
            "ingredients": [
                { "name": "Sugar", "quantity": 5 },
                { "name": "Pink color", "quantity": 10 }
            ]
        },
        handleResponse: (response) => {testDB.cottonCandyId = response.data.id; return assertEquals(response.data.name, "Cotton Candy")},
    },

    {
        name: "GET /recipes/get-count-by-recipe shall work",
        method: "get",
        url: "/recipes/get-count-by-recipe",

        // FIXME! verify specific results
        handleResponse: (response) => {
            const list = response.data;
            return assertMultiEquals([
                ["Response code", response.status, 200],
                ["Data length", list.length, 3],
                ["Recipe " + testDB.sugarCakeId, getItemById(list, testDB.sugarCakeId).count, 11],   
                ["Recipe " + testDB.cinamonBunId, getItemById(list, testDB.cinamonBunId).count, 4],   
                ["Recipe " + testDB.cottonCandyId, getItemById(list, testDB.cottonCandyId).count, 1],   
            ])
        },
    },

    {
        name: "GET /recipes/optimize-total-count shall work",
        method: "get",
        url: "/recipes/optimize-total-count",
        handleResponse: (response) => {
            const list = response.data.recipes;
            return assertMultiEquals([
                ["Response code", response.status, 200],
                ["recipeCount", response.data.recipeCount, 15],
                ["unusedInventoryCount", response.data.unusedInventoryCount, 11],
                ["Data length", list.length, 2],
                ["Recipe " + testDB.sugarCakeId, getItemById(list, testDB.sugarCakeId).count, 11],   
                ["Recipe " + testDB.cinamonBunId, getItemById(list, testDB.cinamonBunId).count, 4],   
            ])
        },
    },
    {
        name: "GET /recipes/optimize-total-waste shall work",
        method: "get",
        url: "/recipes/optimize-total-waste",
        handleResponse: (response) => {
            const list = response.data.recipes;
            return assertMultiEquals([
                ["Response code", response.status, 200],
                ["recipeCount", response.data.recipeCount, 14],
                ["unusedInventoryCount", response.data.unusedInventoryCount, 6],
                ["Recipe " + testDB.sugarCakeId, getItemById(list, testDB.sugarCakeId).count, 9],   
                ["Recipe " + testDB.cinamonBunId, getItemById(list, testDB.cinamonBunId).count, 4],   
                ["Recipe " + testDB.cottonCandyId, getItemById(list, testDB.cottonCandyId).count, 1],   
            ]
        )},
    },


];
